import { Components } from '@ionic/core';
import { IonIcon, IonLabel } from '@ionic/react';
import { closeOutline } from 'ionicons/icons';
import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { BaseButton } from './base-button';

interface CloseButtonProps {
  onClose: () => void;
  label?: string;
  buttonProps?:
    | (Partial<Components.IonButton> &
        Partial<React.HTMLAttributes<HTMLIonButtonElement>> &
        Partial<React.DOMAttributes<HTMLIonButtonElement>>)
    | undefined;
}

const CloseButton = (props: CloseButtonProps): ReactElement => {
  const { onClose, buttonProps, label } = props;
  const { i18n } = useTranslation();
  return (
    <BaseButton
      buttonProps={{
        color: 'danger',
        fill: 'outline',
        onClick: () => {
          onClose();
        },
        ...buttonProps,
      }}
    >
      <IonIcon icon={closeOutline} slot="start" />
      <IonLabel>{label ?? i18n.t('common:close')}</IonLabel>
    </BaseButton>
  );
};

export { CloseButton };
